<script lang="ts" setup>
import { computed, toRefs } from 'vue';

import type { NormalizedPerpsPosition } from '@exchange/libs/account/service/src/lib/wss-account-messages';

import OpenPositionsItemMobile from './OpenPositionsItemMobile.vue';
import MyOrdersListMobile from '../../components/MyOrdersListMobile.vue';

const props = defineProps({
  authenticatedUser: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
  maxLeverage: { type: Number, required: false },
  futuresPositions: { type: Array<NormalizedPerpsPosition>, required: true },
});

const { marketId, futuresPositions } = toRefs(props);

const showInfo = computed(() => Boolean(!futuresPositions.value.length));

const emit = defineEmits(['close-position']);
</script>

<template>
  <my-orders-list-mobile
    class="open-positions-list-mobile"
    :authenticated-user="authenticatedUser"
    :market-id="marketId"
    :mobile-header="[]"
    :show-all-markets="showAllMarkets"
    :show-info="showInfo"
    :is-filled-list="false"
    :is-futures="true"
  >
    <template #list="{ itemClass }">
      <open-positions-item-mobile
        v-for="position in futuresPositions"
        :key="position.instrument_code"
        :class="itemClass"
        :position="position"
        :max-leverage="maxLeverage"
        :is-current-market-position="marketId === position.instrument_code"
        @close-position="(pos) => emit('close-position', pos)"
      />
    </template>
  </my-orders-list-mobile>
</template>
